module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('event-list-filter', {
    attrs: {
      "regions": _vm.regions,
      "types": _vm.types,
      "statuses": _vm.filterStatuses
    },
    on: {
      "apply": _vm.applyFilter
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "30px",
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h1', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("\n        Special price events\n        "), _c('span', {
    staticClass: "badge badge-pill badge-secondary"
  }, [_vm._v(_vm._s(_vm.itemCount))])]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.addEvent
    }
  }, [_vm._v("New")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col event-list"
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Region")]), _vm._v(" "), _c('th', [_vm._v("\n            Start date\n            "), _c('icon', {
    attrs: {
      "name": "sort-desc"
    }
  })], 1), _vm._v(" "), _c('th', [_vm._v("End date")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "display": "contents"
    }
  }, [_vm._l((_vm.events), function(event) {
    return _c('event-list-item', {
      key: event.id,
      attrs: {
        "event": event,
        "regions": _vm.regions,
        "types": _vm.types,
        "statuses": _vm.statuses
      },
      on: {
        "delete": _vm.confirmEventDelete,
        "edit": _vm.editEvent,
        "view": _vm.viewEvent,
        "multiCopy": _vm.multiCopyEvent,
        "copy": _vm.copyEvent,
        "lock": _vm.confirmEventLock,
        "unlock": _vm.confirmEventUnlock
      }
    })
  }), _vm._v(" "), (_vm.events.length === 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("There are currently no events")])]) : _vm._e()], 2)]), _vm._v(" "), (_vm.pagination.last_page > 1) ? _c('pagination', {
    attrs: {
      "pagination": _vm.pagination,
      "offset": 10
    },
    on: {
      "paginate": function($event) {
        _vm.changePage()
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "delete_modal",
      "title": "Are your sure?",
      "ok-title": "Delete"
    },
    on: {
      "ok": _vm.deleteEvent
    },
    model: {
      value: (_vm.deleteConfirmShown),
      callback: function($$v) {
        _vm.deleteConfirmShown = $$v
      },
      expression: "deleteConfirmShown"
    }
  }, [_vm._v("\n    By deleting event all price lists and campaigns will also be deleted\n  ")]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "unlock_modal",
      "title": "Are your sure?",
      "ok-title": "Unlock"
    },
    on: {
      "ok": _vm.unlockEvent
    },
    model: {
      value: (_vm.unlockConfirmShown),
      callback: function($$v) {
        _vm.unlockConfirmShown = $$v
      },
      expression: "unlockConfirmShown"
    }
  }, [_vm._v("\n    This ​ ​will ​ unlock ​ ​the ​ ​promotion, ​ ​are ​ ​you ​ ​sure to ​ unlock ​ ​the ​ ​promotion?\n  ")]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "lock_modal",
      "title": "Are your sure?",
      "ok-title": "Lock"
    },
    on: {
      "ok": _vm.lockEvent
    },
    model: {
      value: (_vm.lockConfirmShown),
      callback: function($$v) {
        _vm.lockConfirmShown = $$v
      },
      expression: "lockConfirmShown"
    }
  }, [_vm._v("\n    This ​ ​will ​ lock ​ ​the ​ ​promotion, ​ ​are ​ ​you ​ ​sure to ​ lock ​ ​the ​ ​promotion?\n  ")]), _vm._v(" "), _c('loading', {
    attrs: {
      "show": _vm.loading
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-49ef70ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/EventList/EventList.vue
// module id = 1686
// module chunks = 1